import * as moment from 'moment';
import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
import { StaticVariable } from 'src/app/globle.class';
import { ReceiptHeader } from '../extras/receipt-header-image';
import { DummyHundiTransactionPojo } from '../receipt-pojo/DummyHundiTransactionPojo';
import { qrPojo } from '../receipt/receipt-qr.pojo';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export class HundiDonationReceipt {

    static printHundiReceipt(arg: DummyHundiTransactionPojo, qrpojo: qrPojo, transactionId: number) {

        let body = [];
        let content = [];

        content.push({
            image: ReceiptHeader.receiptImg, width: 610
        });

        content.push({ text: '' });

        body.push([{ text: 'HUNDI DONATION', bold: true, colSpan: 3, alignment: 'center', margin: [0, 5] }, {}, {}]);

        body.push([
            { text: 'E-RECEIPT', bold: true, colSpan: 2, alignment: 'center', margin: [0, 5] }, {},
            { qr: JSON.stringify(qrpojo), fit: 150, rowSpan: 12, alignment: 'center', margin: [0, 5] }
        ]);

        body.push(['Transaction ID  ', { text: arg.transaction.transactionId, bold: true }, {}]);

        body.push(['Receipt Number  ', { text: arg.hundiDetail.receiptId, bold: true }, {}]);

        body.push(['Receipt Date', moment(arg.hundiDetail.offeredDate).format('DD-MM-YYYY'), {}]);

        body.push(['Name  ', arg.hundiDetail.bookedPersonName, {}]);

        body.push(['City  ', arg.hundiDetail.city, {}]);

        body.push(['Id Proof  ', { text: arg.hundiDetail.idProof, bold: true }, {}]);

        body.push(['Id Number  ', { text: arg.hundiDetail.proofNumber, bold: true }, {}]);

        body.push(['Payment Id  ', arg.transaction.pgPayUId, {}]);

        body.push(['Bank Reference Id  ', arg.transaction.pgBankRefNum, {}]);

        body.push(['Transaction Status  ', { text: arg.transaction.status, bold: true }, {}]);

        let amount = arg.transaction.amount;

        body.push(['Net Amount ', { text: '₹ ' + arg.transaction.amount + ' (' + amount + ' only)', bold: true }, {}]);

        content.push({
            'table': { 'body': body, widths: ['30%', '40%', '30%'] }, margin: [0, 20]
        });

        content.push(
            { text: 'Hundi Donation Terms and conditions:', style: 'header', bold: true },
            {
                ul: [
                    { text: ' If you do not get the print out receipt after successful transaction you may contact the following numbers for further details.' },
                    { text: 'For Support Contact :  Mail id: ' + StaticVariable.mail + ', HelpLine Landline Number : ' + StaticVariable.landLine + ', HelpLine Toll Free Number : ' + StaticVariable.tollFree, fontSize: 10 },
                ]
            }
        );

        const dd = {
            'content': content,
            pageMargins: [20, 5, 20, 5]
        };

        pdfMake.createPdf(dd).download('Receipt - ' + transactionId);
        pdfMake.createPdf(dd).open();
    }

}
